import React from 'react'
import { createUseStyles } from 'react-jss'
import GmapsImage from '../../../assets/img/gmapsBgImage.png'
import { L } from '../../providers/Lokalise'
import { ButtonLink } from '../Button/Button'

interface Props {
    customedGmapsUrl: string
}

const useStyles = createUseStyles(() => ({
    gmapsContainer: {
        position: 'relative',
    },
    gmapsImage: {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
    },
    gmapsButton: {
        position: 'absolute',
        bottom: '.75rem',
        right: '.75rem',
    },
}))

const GmapsLink: React.FC<Props> = ({ customedGmapsUrl }) => {
    const classes = useStyles()
    return (
        <div className={classes.gmapsContainer}>
            <img
                src={GmapsImage}
                alt="gmaps illustration"
                className={classes.gmapsImage}
            />
            <div className={classes.gmapsButton}>
                <ButtonLink
                    type="primary"
                    size="large"
                    href={customedGmapsUrl}
                    target="_blank"
                >
                    {L('GENERISK_VISVEJ_KNAP')}
                </ButtonLink>
            </div>
        </div>
    )
}

export { GmapsLink }
